import { Component, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin } from 'rxjs';
import { LoginService } from "src/app/core/services/login.service";
import { SlsService } from "src/app/core/services/sls.service";
import { DocumentViewerComponent } from "src/app/modules/dashboard/modules/my-directory/pages/document-viewer/document-viewer.component";
import { BasicInfoTabService } from 'src/app/modules/dashboard/modules/my-directory/services/basic-info-tab.service';
import { DirDetailsService } from "src/app/modules/directory/services/dir-details.service";
import { FeedImageComponent } from "src/app/modules/feeds/pages/feed-image/feed-image.component";
import { FeedService } from "src/app/modules/feeds/services/feed.service";

@Component({
  selector: 'app-post-viewer',
  templateUrl: './post-viewer.component.html',
  styleUrls: ['./post-viewer.component.scss']
})
export class PostViewerComponent implements OnInit {
    feedId!: string | null;
    feedData: any;
    feeDirdData: any;
    talentData: any;
    showSharePopup: boolean = false;
  
  
    constructor(
      private route: ActivatedRoute,
      private router: Router,
      private feedService: FeedService,
      private loginService: LoginService,
      private basicInfoTabService:BasicInfoTabService,
      private _dialog: MatDialog,
      private sls: SlsService,
      private spinner: NgxSpinnerService,
      private dirDetailsService: DirDetailsService
    ) { }
  
  ngOnInit(): void {
    this.spinner.show();

    const queryParams = this.route.snapshot.queryParamMap;
    const id = queryParams.get('id');
    const popup = queryParams.get('popup') === 'true';
    if (!id) {
      this.spinner.hide();
      return;
    }
    if (popup) {
      this.showSharePopup = true;
    }

    // Fetch all data in parallel
    forkJoin({
      feed: this.feedService.getfeedDataPreloginByid(id),
      directory: this.dirDetailsService.getDirectoryPreloginByid(id),
      talent: this.basicInfoTabService.getTalentPreloginByid(id)
    }).subscribe({
      next: ({ feed, directory, talent }) => {
        this.feedData = feed[0];
        this.feeDirdData = directory;
        this.talentData = talent;
        this.spinner.hide();
      },
      error: (err) => {
        console.error('Error fetching data', err);
        this.spinner.hide();
      }
    });
  }


  closeChatPopup(): void {
    this._dialog.closeAll();
  }
  
  
    getPostImagesAndVideos(feedData: any): any[] {
      let mediaFiles: any[] = [];
  
      if (!feedData) {
        return [];
      }
  
      // FEED POST images
      if (feedData?.post_image) {
        mediaFiles = Array.isArray(feedData.post_image)
          ? feedData.post_image
          : [feedData.post_image];
      }
  
      // JOB banner
      if (feedData?.feed_type === 'JOB' && feedData?.banner_image) {
        mediaFiles.push({
          url: feedData.banner_image,
          type: 'image',
          mime_type: 'image/png',
          name: 'job-banner_logo',
          file_id: feedData.id,
        });
      }
  
      // LEARNHUB course banners (images + videos)
      if (feedData?.feed_type === 'LEARNHUB' && feedData?.courses?.length) {
        const course = feedData.courses[0]; // take first course 
  
        // Images
        if (course?.course_banner_image) {
          const banners = Array.isArray(course.course_banner_image)
            ? course.course_banner_image
            : [course.course_banner_image];
  
          mediaFiles.push(
            ...banners.map(banner => ({
              url: banner.url,
              type: 'image',
              mime_type: banner.type || 'image/jpeg',
              name: banner.name || 'course-banner-image',
              file_id: feedData.id,
            }))
          );
        }
  
        // Videos
        if (course?.course_banner_video) {
          const videos = Array.isArray(course.course_banner_video)
            ? course.course_banner_video
            : [course.course_banner_video];
  
          mediaFiles.push(
            ...videos.map(video => ({
              url: video.url,
              type: 'video',
              mime_type: video.type || 'video/mp4',
              name: video.name || 'course-banner-video',
              file_id: feedData.id,
            }))
          );
        }
      }
  
      // filter only valid image/video
      const validMedia = mediaFiles.filter(
        media => this.isImage(media) || this.isVideo(media)
      );
  
      return validMedia;
    }
  
    get displayedMedia(): any[] {
      const mediaFiles = this.getPostImagesAndVideos(this.feedData);
      return mediaFiles.slice(0, 4);
    }
  
    get remainingCount(): number {
      const mediaFiles = this.getPostImagesAndVideos(this.feedData);
      return mediaFiles.length > 4 ? mediaFiles.length - 3 : 0;
    }
  
    isVideo(media: any): boolean {
      if (!media?.url) return false;
      return media?.type?.includes('video') || /\.(mp4|webm|ogg)$/i.test(media.type);
    }
    isImage(media: any): boolean {
      if (!media?.url) return false;
      return (
        media?.type?.includes('image') ||
        media?.mime_type?.includes('image') ||
        /\.(jpeg|jpg|png|gif)$/i.test(media.url)
      );
    }
    isDocument(media: any): boolean {
      if (!media?.url) return false;
      return media?.type?.includes('pdf') || media?.type?.includes('application/msword') || /\.(pdf|doc|docx|xls|xlsx|ppt|pptx)$/i.test(media.url);
    }
  
    viewallDocuments(document, index: number,): void {
      // document =[...document, ...this.getPostDocuments(this.feed)];
      if (JSON.stringify(document) === JSON.stringify(this.displayedMedia)) {
  
        const datas1 = this.getPostImagesAndVideos(this.feedData);
  
        document = [...datas1, ...this.getPostDocuments(this.feedData)];
      }
      else {
        const datas1 = this.getPostImagesAndVideos(this.feedData);
  
        document = [...this.getPostDocuments(this.feedData), ...datas1]
      }
  
      this._dialog.open(DocumentViewerComponent, {
        width: '70%',
        panelClass: ['custom-modal'],
        data: {
          documents: document,
          initialIndex: index
        }
      });
    }
    getPostDocuments(feedData: any): any[] {
      if (!feedData?.post_image) return [];
      let mediaFiles = Array.isArray(feedData.post_image) ? feedData.post_image : [feedData.post_image];
      return mediaFiles.filter(media => this.isDocument(media));
    }
  
  
    feedImageView(selectedMedia: any, feedData: any) {
      const mediaArray = this.getPostImagesAndVideos(feedData);
  
      if (!mediaArray || !Array.isArray(mediaArray)) {
        console.error('Error: mediaArray is not defined or is not an array', mediaArray);
        return;
      }
      const mediaItems = mediaArray
        .filter(item => this.isImage(item) || this.isVideo(item))
        .map(item => ({ url: item?.url, type: this.isImage(item) ? 'image' : 'video' }))
        .filter(item => item.url);
  
      const selectedIndex = mediaItems.findIndex(item => item.url === selectedMedia?.url);
  
      if (selectedIndex === -1) {
        console.error('Error: Selected media not found in media array', selectedMedia);
        return;
      }
      // const hasMultipleMedia = mediaItems.length > 1;
      this._dialog.open(FeedImageComponent, {
        width: '65%',
        panelClass: ['custom-modal'],
        data: { mediaItems, selectedIndex }
      });
    }
  
  
  
    ////////// chandru 
  
    /** Time */
    get displayTime(): string | null {
      return this.feedData?.created_at ?? null;
    }
  
    /** Admin check */
    get isAdmins(): boolean {
      return this.feedData?.user_role === 'ADMIN';
    }
  
    /** Avatar URL resolution */
    get avatarUrl(): string | null {
      if (this.isAdmins) return null;
  
      return (
        this.feedData?.dental_supplier?.directories?.[0]?.logo?.url ??
        this.feedData?.dental_supplier?.logo?.url ??
        this.feedData?.dental_practice?.directories?.[0]?.logo?.url ??
        this.feedData?.dental_professional?.profile_image?.url ??
        null
      );
    }
  
    /** Display name resolution */
    get displayName(): string {
      if (this.isAdmins) return 'Dental Interface';
  
      const type = this.feedData?.feedData_type;
  
      if (
        ['CATALOGUE', 'JOBS', 'LEARNHUB'].includes(type) &&
        this.feedData?.dental_supplier?.directories?.[0]?.company_name
      ) {
        return this.feedData.dental_supplier.directories[0].company_name;
      }
  
      if (this.feedData?.dental_supplier_id && type !== 'CATALOGUE') {
        return this.feedData?.dental_supplier?.name ?? '';
      }
  
      if (this.feedData?.dental_professional_id) {
        return this.feedData?.dental_professional?.name ?? '';
      }
  
      if (this.feedData?.dental_practice_id) {
        return this.feedData?.dental_practice?.name ?? '';
      }
  
      return this.feedData?.dental_supplier?.name ?? '';
    }
  
    /** Whether to show <img> or initials */
    get showAvatarImage(): boolean {
      return this.isAdmins || !!this.avatarUrl;
    }
  
    /** Initials fallback */
    get initials(): string {
      const source =
        this.feedData?.dental_supplier?.directories?.[0]?.company_name ??
        this.feedData?.dental_supplier?.name ??
        this.feedData?.dental_practice?.name ??
        this.feedData?.dental_professional?.name ??
        '';
  
      return source.charAt(0).toUpperCase();
    }
  
  
  
    /** Image error handler */
    onImageError(event: Event, fallbackFileName = 'alt_img.jpg'): void {
      const img = event?.target as HTMLImageElement | null;
      if (img) {
        img.src = `../../../../../assets/images/${fallbackFileName}`;
        img.onerror = null;
      }
    }
  
    /** Show avatar/name/time only for these feed types */
    get shouldShowUserInfo(): boolean {
      const type = this.feedData?.feed_type;
      return ['CATALOGUE', 'JOBS', 'LEARNHUB'].includes(type);
    }
  
}
